var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5Post(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "212px",
    viewBox: "0 0 500 212",
    style: {
      enableBackground: "new 0 0 500 212"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5EBC52;}\r\n\t.st1{fill:#58595B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,212c-38.4,0-73.1-21.7-90.2-55.3c-3.4-6.6-0.2-14.7,6.8-17.2c5.7-2,12.1,0.5,14.8,5.9 c12.9,25.5,39.3,42.1,68.5,42.1c24.8,0,47.5-11.9,61.7-31c4.6-6.2,10.9-16,10.9-31.8l21.9,22.9c0,0-1.2,3.3-3.4,7.5 c-2.2,4.2-3.1,5.7-4.5,8C160.2,193,127.5,212,91.5,212z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.9,105.1c-0.9-12.3-6.4-22.1-15.8-28.3c-7.9-5.2-18.4-7.9-31.4-7.9h-1.5v0H78.5v-20h40.9 c6.1,0,11.1-4.6,11.1-10.6c0-6-5.1-10.9-11.1-10.9H67.4c-6.2,0-11.1,5-11.1,11.1v40.8c0,6.1,5,11.1,11.1,11.1h25.8 c17.3,0,22.7,7.9,22.7,16.1c0,8-4.3,20.9-22.5,20.9c-15,0-23.9-10.1-25.8-11.8c-5.5-5-11.1-4.6-14.8-1.4c-4.7,4.2-4.1,10-1.3,14.4 c3.4,5.1,16.6,21.1,41.9,21.1c14.3,0,27-5.1,35.7-14.5C136.8,127,140.7,116,139.9,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.4,119.7c-12.2-0.6-23.7-5.6-29-10.3c-5.8-5.2-6.9-12.2-2.4-16.2c5.9-5.1,11.9-0.4,14.4,1.1 c13.2,8.2,23.8,7.6,28.8,3.6c2.9-2.3,4.1-5.2,3.7-7.6c-0.7-4.3-5.8-5.9-12.1-7.6c-4.8-1.3-17.6-5.1-23.6-8.5 c-8.7-5-14.7-13.4-12.6-25c2.1-12.3,12.8-21.6,26.6-22.9c17.6-1.6,26.2,2.6,31.2,5.3c7.2,3.9,8.6,11.8,4.8,16.3 c-1.7,2.1-6.8,4-11.9,1.8c-17.4-7.7-26.3-5.6-28.5-1.1c-2.4,4.8,1.9,9.4,7.5,11.5c0.3,0.1,3.7,1.5,8.4,3c4.1,1.3,9.1,2.7,14.6,4.7 c10.1,3.8,18.6,11.8,17.4,25.2c-0.7,7.1-4.9,15-11.2,19.6C411.8,116.3,402.7,120.3,390.4,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.9,98.3c-2.6-1-6.3-0.5-8.6-0.2c-3,0.5-7.7,1.1-11.5,0c-6.7-1.9-9.2-5.7-9.2-11.6V47.3h15.9 c6,0,10.9-4.7,10.9-10.4c0-5.8-4.9-10.4-10.9-10.4h-15.9v-15c0-6.3-5.1-11.4-11.4-11.4c-6.3,0-11.4,5.1-11.4,11.4v15h-5.2 c-6,0-10.9,4.7-10.9,10.4c0,5.8,4.9,10.4,10.9,10.4h5.2v39.3c0,18.4,14.7,33.5,33.5,33.5c18.8,0,23.7-6.7,23.7-13 C500,102.5,498.5,99.6,494.9,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.4,26.4c-25.1,0-45.6,20.9-45.6,46.7c0,25.7,20.5,46.7,45.6,46.7v0v0c25.1,0,45.6-20.9,45.6-46.7 C353,47.3,332.5,26.4,307.4,26.4z M307.4,98.7c-13,0-23.6-9.2-23.6-25.6c0-16.4,10.6-25.7,23.6-25.7v0v0c13,0,23.6,9.3,23.6,25.7 C330.9,89.5,320.4,98.7,307.4,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.9,26.4c-8.9,0-20.1,5.2-25.8,13.2c-0.3-7.7-4.5-12.9-10.5-12.9c-6.3,0-11.4,5.1-11.4,11.4v105 c0,6.3,5.1,11.4,11.4,11.4c6.3,0,11.4-5.1,11.4-11.4v-34.5c4.3,5.6,15.1,11.1,25.8,11.1c25.1,0,43.2-21,43.2-46.7 C256,47.3,237.8,26.4,211.9,26.4z M210.4,98.7c-14.6,0-24.7-10.2-24.7-25.6c0-16.9,12.3-25.7,24.7-25.7c13,0,23.6,12.2,23.6,25.7 C234,86.6,223.4,98.7,210.4,98.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Post);
export default __webpack_public_path__ + "static/media/5post.3f6d38fc98f021c2153ca44c125c8158.svg";
export { ForwardRef as ReactComponent };